import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from './config.service';
import { LocaleService } from './locale.service';
import { ViewName, Route, Session } from '@fpr/core/models/session.models';

@Injectable({
    providedIn: 'root'
})
export class SessionManager {
    private readonly router = inject(Router);
    private readonly configService = inject(ConfigService);
    private readonly localeService = inject(LocaleService);


    private readonly SESSION_MAP_NAME = 'fpr.sessions';
    private sessionMap = {};

    private readonly viewRoutes: { [key in ViewName]?: Route } = {
        CREATE_PARTY: '/create-party',
        SELECT_DATE_AND_PARK: '/select-date-and-park',
        SEGMENT_DETECTION: '/checking-tickets',
        UNABLE_TO_RESERVE: '/unable-to-reserve',
        SELECT_TIME: '/select-time',
        REVIEW_AND_CONFIRM: '/review-and-confirm',
        CONFIRMATION: '/confirmation',
        CONFLICT: '/just-a-moment',
        ERROR: '/error',
        RESERVATION_DETAILS: '/details',
        CANCEL_PARTY: '/cancel/party'
    };

    constructor() {
        this.sessionMap = JSON.parse(sessionStorage.getItem(this.SESSION_MAP_NAME)) || {};
    }

    goTo(view: ViewName, session?: Session): void {
        if (session) {
            this.setSession(view, session);
        }
        this.router.navigate([this.viewRoutes[view]]);
    }

    getSession(view: ViewName): Session {
        return this.sessionMap[view] || {};
    }

    setSession(view: ViewName, session: Session): void {
        this.sessionMap[view] = session;
        sessionStorage.setItem(this.SESSION_MAP_NAME, JSON.stringify(this.sessionMap));
    }

    clearSessionItem(view: ViewName): void {
        this.sessionMap[view] = {};
        sessionStorage.setItem(this.SESSION_MAP_NAME, JSON.stringify(this.sessionMap));
    }

    clearSession(): void {
        this.sessionMap = {};
        sessionStorage.removeItem(this.SESSION_MAP_NAME);
    }

    getRouteFromViewName(viewName: ViewName, includeBasePath = false): string {

        const route = this.viewRoutes[viewName];

        if (includeBasePath) {
            return this.localeService.getPathWithLocale(`${this.configService.APP_CONTEXT_PATH}${route}`);
        }

        return route;

    }

    getViewNameFromRoute(route?: string): ViewName {
        return Object.keys(this.viewRoutes)
            .find(key => this.viewRoutes[key] === route) as ViewName;
    }

}
